




































import {
  defineComponent,
  reactive,
  toRefs,
  computed,
  onUnmounted
} from '@vue/composition-api'

export default defineComponent({
  name: '',
  components: {},
  props: {
    appViews: {
      default: []
    },
    currentIndex: {
      default: 0
    }
  },
  emits: [],
  setup() {
    const state = reactive({
      naturalWidth: 0,
      naturalHeight: 0,
      width: 0,
      height: 0
    })
    const getImage = (element: any) => {
      state.naturalWidth = element.srcElement.naturalWidth || 0
      state.naturalHeight = element.srcElement.naturalHeight || 0
      const BiggestWidth = document.body.clientWidth * 0.8
      const BiggestHeight = document.body.clientHeight * 0.8
      // 计算图片开始展示适应屏幕
      if (
        state.naturalWidth < BiggestWidth &&
        state.naturalHeight < BiggestHeight
      ) {
        state.width = state.naturalWidth
        state.height = state.naturalHeight
        return
      }
      if (
        state.naturalWidth / BiggestWidth >
        state.naturalHeight / BiggestHeight
      ) {
        state.width = BiggestWidth
        state.height = (BiggestWidth / state.naturalWidth) * state.naturalHeight
      } else {
        state.height = BiggestHeight
        state.width = (BiggestHeight / state.naturalHeight) * state.naturalWidth
      }
    }
    const smallSize = () => {
      if (percent.value < 1) {
        return
      }
      state.width = state.width * 0.8
      state.height = state.height * 0.8
    }
    const bigSize = () => {
      if (percent.value > 1000) {
        return
      }
      state.width = state.width * 1.25
      state.height = state.height * 1.25
    }
    const percent = computed(() => {
      return Math.round((state.width / state.naturalWidth) * 100)
    })

    onUnmounted(() => {
      document.body.style.overflow = ''
    })

    return {
      ...toRefs(state),
      getImage,
      smallSize,
      bigSize,
      percent
    }
  }
})
